import { useForm } from 'react-hook-form';
import { ResetPasswordData } from '../../account/types';

type Props = {
  onSubmit: (data: ResetPasswordData) => void
}

export const ResetPasswordForm = ({ onSubmit }: Props) => {
  const { register, handleSubmit, formState: { isSubmitting } } = useForm<ResetPasswordData>();

  return (
    <form
      className='flex flex-col w-full p-4'
      onSubmit={handleSubmit(onSubmit)}
    >
      <label>Email:</label>
      <input
        {...register('email', { required: true })}
        autoComplete='email'
        autoFocus
        className='mt-1 mb-4 mx-4 rounded-sm p-2 text-neutral-700'
      />
      <input
        className='border rounded-sm p-2 px-4 self-center hover:bg-white hover:text-jw-blue cursor-pointer'
        disabled={isSubmitting}
        type='submit'
        value='Send password reset link'
      />
    </form>
  );
};
